import EquinetPremium from './EquinetPremium';

export default EquinetPremium;
